import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './AddMeetTimeIndividualValidation';

import { getMeetDates } from '../utils/MeetUtils';

import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useMeetTimesData from '@usas/ui-web/state/meet/meetTimes/UseMeetTimesData';
import useEventData from '@usas/ui-web/state/event/UseEventData';
import useLscData from '@usas/ui-web/state/lsc/UseLscData';

import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';
import { formatTimeForFilterObject } from '@usas/ui-web/utils/TimesUtils';

import NavLinks from '../../NavLinks';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const useAddMeetTimeIndividual = () => {
  const navigate = useNavigate();
  const [state, setState] = useState(getInitialState);
  const { eventState, getEvents } = useEventData();
  const { meetState } = useMeetData();
  const { lscState } = useLscData();
  const { postMeetTime, meetTimeAddPostDataState, setMeetTimeAddPostDataState, meetTimesAddState } = useMeetTimesData();
  const {
    formState,
    errorState,
    handleSubmit,
    setFormState,
    setFormData,
    updateFormState,
    onValueTextPairChanged
  } = useForm(getInitialFormState, submitFormCallback, validate);

  const [meetDatesState, setMeetDatesState] = useState([
    { id: Constants.DEFAULT_ID, name: "Select a Swim Date" }
  ]);

  const [sessionTypeState] = useState([
    { id: Constants.DEFAULT_ID, name: "Select a Session Type" },
    { id: 1, name: "Prelim" },
    { id: 2, name: "SwimOff" },
    { id: 3, name: "Final" },
    { id: 4, name: "SemiFinal" },
    { id: 5, name: "QuarterFinal" },
    { id: 6, name: "TimedFinal" }
  ]);

  function submitFormCallback(formState) {
    postMeetTime(createMeetTimeIndividualObject(formState))
    setState({
      ...state,
      tryPageRedirect: true
    })
  };

  const createMeetTimeIndividualObject = (formState) => {
    return {
      personId: formState.personId,
      personName: formState.personName,
      eventId: formState.eventId,
      meetId: formState.meetId,
      eventCompetitionGenderTypeId: formState.personGender,
      sessionId: formState.sessionId,
      time: formatTimeForFilterObject(formState.time),
      swimDate: formState.swimDate,
      finishPosition: parseInt(formState.finishPosition.trim()),
      isLeadOffTime: formState.isLeadOffTime,
      lscCode: lscState.data.find(x => x.orgUnitId === formState.lscId).orgUnitCode,
      clubCode: formState.clubCode,
      eventNumber: parseInt(formState.eventNumber.trim()),
      eventAgeMin: parseInt(formState.eventAgeMin.trim()),
      eventAgeMax: parseInt(formState.eventAgeMax.trim())
    }
  } 

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    navigate(NavLinks.MEET_TIMES_ADD_MEET_TIME_SELECT_TIME_TYPE);
  };

  useEffect(() => {
    if (meetTimeAddPostDataState.isSaved === true
      && state.tryPageRedirect === true) {
      const newArrayData = meetTimeAddPostDataState.arrayData;
      newArrayData.push(meetTimeAddPostDataState.objData);
      setMeetTimeAddPostDataState({
        ...meetTimeAddPostDataState,
        arrayData: newArrayData,
        isSaved: false
      })
      navigate(NavLinks.MEET_TIMES_ADD_MEET_TIME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetTimeAddPostDataState, state.tryPageRedirect]);

  useEffect(() => {
    if (meetState.isObjLoaded === true) {
      const startDate = formatDate(meetState.objData.startDate);
      const endDate = formatDate(meetState.objData.endDate);
      const meetDatesRange = getMeetDates(startDate, endDate).map((date, i) => {
        return {
          id: i + 1,
          name: date
        }
      })
      setMeetDatesState([
        { id: Constants.DEFAULT_ID, name: "Select a Swim Date" },
        ...meetDatesRange
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetState]);

  useEffect(() => {
    if (eventState.isArrayLoaded === false) {
      getEvents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    formState,
    errorState,
    eventState,
    meetDatesState,
    meetTimeAddPostDataState,
    sessionTypeState,
    onFormValueChanged: updateFormState,
    onValueTextPairChanged,
    handleSubmit,
    onCancelClicked,
    setFormData,
    lscState,
    meetState
  };

  function getInitialFormState() {
    return {
      personId: '',
      personName: '',
      personGender: '',
      eventId: Constants.DEFAULT_ID,
      meetId: meetState.objData.meetId,
      sessionId: Constants.DEFAULT_ID,
      time: '',
      swimDate: '',
      swimDateId: Constants.DEFAULT_ID,
      finishPosition: '',
      isLeadOffTime: false,
      eventName: '',
      competitorName: '',
      memberId: '',
      lscId: '',
      clubCode: '',
      eventNumber: '',
      eventAgeMin: '',
      eventAgeMax: ''
    };
  }

  function getInitialState() {
    return {
      tryPageRedirect: false
    };
  };
}

export default useAddMeetTimeIndividual;